var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "text-center share" }, [
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v("Deel deze story")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-16 d-flex justify-content-center" }, [
        _c("a", {
          staticClass: "linkedin mr-8",
          attrs: {
            target: "_blank",
            href:
              "https://www.linkedin.com/shareArticle?mini=true&url=" +
              _vm.url +
              "&title=" +
              _vm.story.title.rendered
          }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "facebook mr-8",
          attrs: {
            target: "_blank",
            href: "https://www.facebook.com/sharer/sharer.php?u=" + _vm.url
          }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "email mr-8",
          attrs: {
            href:
              "mailto:?subject=" +
              _vm.story.title.rendered +
              " - ToffeTeambuildings.be&body=Lees hier de story: " +
              _vm.url
          }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "whatsapp mr-8 mr-lg-0",
          attrs: { href: "whatsapp://send?text=" + _vm.url }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "messenger d-lg-none",
          attrs: {
            href: "fb-messenger://share/?link=" + _vm.url + "&app_id=123456789"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }